import { render, staticRenderFns } from "./ServiceDetails.vue?vue&type=template&id=f71e6a04&scoped=true"
import script from "./ServiceDetails.vue?vue&type=script&lang=js"
export * from "./ServiceDetails.vue?vue&type=script&lang=js"
import style0 from "./ServiceDetails.vue?vue&type=style&index=0&id=f71e6a04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71e6a04",
  null
  
)

export default component.exports